<div class="app-logo"
[ngClass]="
{
  'small': size === 'small',
  'medium': size === 'medium',
  'responsive': responsive}
  ">
  <div class="logo-image-container">
    <img src="/assets/bh-logos/bh-stacked-wh.png" class="logo-image">
  </div>
  <div class="medium-divider"></div>
  <div class="app-logo-name" [ngStyle]="{ 'color': color }">
    <div class="app-logo-name-container">
      <span class="app-logo-name-text">{{ appName }}</span>
      <div class="app-logo-icon-wrapper">
        <div class="dev-badge-wrapper" *ngIf="!env.production">
          <a href="javascript:void(0)" (click)="devInfo()" class="dev-badge">DEV</a>
        </div>
        <div class="app-logo-icon" [ngClass]="{'transparent-icon': transparentIcon}"></div>
      </div>
    </div>
  </div>
</div>
